import { createStore } from 'vuex';

import { api } from 'JIX/utils.js';

export const Tabs = Object.freeze({
    ABOUT: "ABOUT",
    JOBS: "JOBS",
    EVALUATIONS: "EVALUATIONS",
    TRAINEE: "TRAINEE",
    GRADUATE: "GRADUATE",
    PAY: "PAY",
    JOBADSTATISTICS: "JOBADSTATISTICS",
    NEWS: "NEWS",
});

function tabTitle(state, tab) {
    let title = {
        [Tabs.ABOUT]: state.titles.ABOUT,
        [Tabs.JOBS]: state.titles.JOBS,
        [Tabs.EVALUATIONS]: state.titles.EVALUATIONS,
        [Tabs.TRAINEE]: state.titles.TRAINEE,
        [Tabs.GRADUATE]: state.titles.GRADUATE,
        [Tabs.PAY]: state.titles.PAY,
        [Tabs.JOBADSTATISTICS]: state.titles.JOBADSTATISTICS,
        [Tabs.NEWS]: state.titles.NEWS,
    }[tab];

    return title;
}

function tabDescription(state, tab) {
    let description = {
        [Tabs.ABOUT]: state.metaDescriptions.ABOUT,
        [Tabs.JOBS]: state.metaDescriptions.JOBS,
        [Tabs.EVALUATIONS]: state.metaDescriptions.EVALUATIONS,
        [Tabs.TRAINEE]: state.metaDescriptions.TRAINEE,
        [Tabs.GRADUATE]: state.metaDescriptions.GRADUATE,
        [Tabs.PAY]: state.metaDescriptions.PAY,
        [Tabs.JOBADSTATISTICS]: state.metaDescriptions.JOBADSTATISTICS,
        [Tabs.NEWS]: state.metaDescriptions.NEWS,
    }[tab];

    return description;
}

const getters = {
};

const mutations = {
    changeTab(state, { tab }) {
        state.selectedTab = tab;
        if (state.proofMode) {
            return;
        }
        const url = state.urls[tab];
        window.history.replaceState(
            { selectedTab: tab, selectedSection: state.selectedSection },
            '', url);
        window.jixAnalytics('pageview', { path: url });
        const title = tabTitle(state, tab);
        const description = tabDescription(state, tab);
        document.querySelector('meta[name="description"]').setAttribute("content", description);
        document.title = title;
    },
    addJobs(state, { jobs }) {
        state.jobsContent.jobsContentHtml.push.apply(state.jobsContent.jobsContentHtml, jobs);
    },
    setFollowing(state, { following }) {
        state.following = following;
    },
    updateStats(state, { adstatistics }) {
        state.adstatisticsContent = adstatistics;
    },
    updateStartDateChannels(state, date) {
        state.adstatisticsContent.channelDates.jixFormat.start = date;
    },
    updateEndDateChannels(state, date) {
        state.adstatisticsContent.channelDates.jixFormat.end = date;
    },
    updateStartDateAreas(state, date) {
        state.adstatisticsContent.areaDates.jixFormat.start = date;
    },
    updateEndDateAreas(state, date) {
        state.adstatisticsContent.areaDates.jixFormat.end = date;
    },
};

const actions = {
    selectTab({ state, commit }, { tab }) {
        if (state.activeTabs.includes(tab)) {
            commit('changeTab', { tab });
        } else {
            commit('changeTab', { tab: Tabs.ABOUT });
        }
    },
    loadJobs({ state, commit }, { page }) {
        return api("GET", '/virksomhed/jobs', { page: page, companyid: state.companyId }).then(({ jobsContentHtml }) => {
            commit('addJobs', { jobs: jobsContentHtml });
        });
    },
    jixAnalytics(state, { label, action }) {
        const data = {
            category: 'virksomhedsprofil',
            label,
            action,
        };
        window.jixAnalytics('event', data);
    },
    updateAdstatistics({ state, commit }) {
        return api("GET", '/virksomhed/annoncestatistik', {
            is_api: 1,
            companyid: state.companyId,
            startDateChannels: state.adstatisticsContent.channelDates.jixFormat.start,
            endDateChannels: state.adstatisticsContent.channelDates.jixFormat.end,
            startDateAreas: state.adstatisticsContent.areaDates.jixFormat.start,
            endDateAreas: state.adstatisticsContent.areaDates.jixFormat.end,
        }).then((adstatistics) => {
            commit('updateStats', { adstatistics });
        });
    },
};

export default (data) => {
    return createStore({
        state() {
            return { ...data };
        },
        getters,
        mutations,
        actions,
    });
};
